import React, { useState, useEffect } from "react"
import { Typography, AppBar, Toolbar, IconButton, Avatar, Menu, MenuItem, Box } from "@mui/material"
import { useAuth } from "../context/AuthContext" // ✅ Import context
import dayjs from "dayjs"
import { keyframes } from "@mui/system"

const pulse = keyframes`
  0% { transform: scale(1); opacity: 0.7; }
  50% { transform: scale(1.2); opacity: 1; }
  100% { transform: scale(1); opacity: 0.7; }
`

const fadeIn = keyframes`
  0% { opacity: 0; transform: translateY(-3px); }
  100% { opacity: 1; transform: translateY(0); }
`

function ProtectedRouteHeader({ lastUpdated, client }) {
  const { user, setAuthToken } = useAuth() // ✅ Access user and logout method
  const [anchorEl, setAnchorEl] = useState(null)

  const open = Boolean(anchorEl)
  const name = user?.name || "User"
  const organization_name = user?.organization_name || ""

  const handleMenuClick = (event) => {
    // setAnchorEl(event.currentTarget);
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleLogout = () => {
    setAuthToken(null) // ✅ Clears both token and user in context + storage
    window.location.href = "/"
  }

  return (
    <AppBar position="static" sx={{ background: "var(--va-main-bg)", height: "64px", width: "100%" }} className="Va-Main-App-Bar">
      <Toolbar sx={{ flexWrap: "wrap", width: "calc(100% - 24px)", maxWidth: "calc(100% - 48px)" }}>
        <Typography variant="h6" sx={{ flexGrow: 1, maxWidth: "100%", overflow: "hidden" }}>
          Hi, {"DEMO USER"} - {"DEMO ORGANIZATION"}
        </Typography>

        {client && (
          <Typography
            variant="body2"
            sx={{
              mr: 2,
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontSize: "0.80rem",
              opacity: 0.85,
              animation: `${fadeIn} 0.6s ease`,
              color: "var(--va-sub-text)",
            }}
          >
            {/* PULSE DOT */}
            <Box
              sx={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                background: "white",
                animation: `${pulse} 2.4s infinite ease-in-out`,
                boxShadow: "0 0 6px var(--va-accent)",
              }}
            />
            {/* Last Updated: {lastUpdated || "—"} */}
            Last Updated: <span style={{ fontWeight: 600 }}>{dayjs(new Date()).format("DD MMM YYYY HH:MM a")}</span>
          </Typography>
        )}

        <IconButton color="inherit" onClick={handleMenuClick}>
          <Avatar>{name.charAt(0).toUpperCase()}</Avatar>
        </IconButton>
        <Menu anchorEl={anchorEl} open={open} onClose={handleClose} anchorOrigin={{ vertical: "top", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }}>
          <MenuItem onClick={handleClose}>Profile</MenuItem>
          <MenuItem onClick={handleClose}>Settings</MenuItem>
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  )
}

export default ProtectedRouteHeader
